<template>
  <div class="content">
    <Loader :loadType="1" v-show="isShowLoader" class="black" style="top:-55px;"></Loader>
    <div class="header" :style="`padding-bottom:${cardInfo || true ? 48 : 22}px`">
      <h1>我的兑换<span>当前账户积点：{{userInfo.statistics.balance || 0}}</span></h1>
      <div class="stat">
        <div class="stat_wrap">
          <div class="stat_wrap_content">
            <span class="title">卡类型：</span>
            <div class="card_type">O-TECH兑换卡<img src="@/assets/images/icons/member/icon_xuanzhong.png"></div>
            <div class="title">兑换卡密码：</div>
            <div class="inputs clearfix">
              <Input type="text" v-model.trim="cardNo.f1" :maxlength="4" @on-change="cardInputEvent($event, 'cardNoF2')" ref="cardNoF1"></Input>
              <span>-</span>
              <Input type="text" v-model.trim="cardNo.f2" :maxlength="4" @on-change="cardInputEvent($event, 'cardNoF3')" ref="cardNoF2"></Input>
              <span>-</span>
              <Input type="text" v-model.trim="cardNo.f3" :maxlength="4" @on-change="cardInputEvent($event, 'cardNoF4')" ref="cardNoF3"></Input>
              <span>-</span>
              <Input type="text" v-model.trim="cardNo.f4" @on-change="cardInputEvent" ref="cardNoF4"></Input>
            </div>
          </div>
          <div class="info" v-if="cardInfo">
            <span class="times">【{{cardInfo.integral}}】</span>
            <span class="name">{{cardInfo.name}}</span>
            <span class="expire" v-if="cardInfo.type === 1 && cardInfo.expiryTime">有效期：{{cardInfo.expiryTime | dataFormat('dateTime.short2')}}</span>
            <span class="expire" v-else>有效期：{{(new Date()).getTime() | getMCardAfterMonthsTimestamp(cardInfo.vip, cardInfo.vipExpire) | dataFormat('dateTime.short2')}}</span>
          </div>
          <div class="subcribe" v-if="!cardInfo">如果您的卡密码不足16位，请用0补足至16位</div>
        </div>
        <Button type="primary" class="btn" :loading="isShowModalLoader" @click="ok">
          <span v-if="!isShowModalLoader"><span>立即兑换</span></span>
          <span v-else>立即兑换</span>
        </Button>
      </div>
    </div>
    <div class="table_content">
      <span v-if="userInfo.vip && userInfo.vip.balance > 0" class="expire_jf">您有{{userInfo.vip.balance}}积点 将于{{userInfo.vip.vipExpiryTime | dataFormat('dateTime.short2')}}到期</span>
      <Tabs value="list">
        <TabPane label="兑换记录" name="list">
          <Table :columns="columns" :data="list" :loading="loaderQuery" no-data-text="暂无兑换记录"></Table>
          <Page :total="total" :page-size="pageSize" size="small" @on-change="getList" v-if="total > pageSize"></Page>
        </TabPane>
      </Tabs>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/layout/Loader'

export default {
  name: 'MyIntegralContent',
  components: { Loader },
  data () {
    return {
      isSubmit: false,
      isShowLoader: false,
      loaderQuery: false,
      isShowModalLoader: false,
      cardInfo: null,
      cardCode: null,
      cardNo: {
        f1: '',
        f2: '',
        f3: '',
        f4: ''
      },
      total: 0,
      pageSize: 8,
      userInfo: { statistics: {} },
      columns: [
        {
          title: '卡号',
          key: 'name',
          align: 'center'
        },
        // {
        //   title: '卡号',
        //   key: 'code',
        //   align: 'center'
        // },
        {
          title: '积点',
          key: 'integral',
          align: 'center'
        },
        {
          title: '会员类型',
          key: 'vip',
          align: 'center',
          render: (h, params) => {
            return h('span', this.$options.filters.getVipTypeName(params.row.vip).name || '-')
          }
        },
        {
          title: '有效期',
          key: 'vipExpire',
          align: 'center',
          render: (h, params) => {
            return h('span', params.row.vipExpire ? this.$options.filters.dataFormat(this.$options.filters.getMCardAfterMonthsTimestamp(params.row.createTime, params.row.vip, params.row.vipExpire), 'dateTime.short2') : '-')
          }
        },
        {
          title: '兑换时间',
          key: 'createTime',
          align: 'center',
          render: (h, params) => {
            return h('span', this.$options.filters.dataFormat(params.row.createTime, 'dateTime.f1'))
          }
        }
      ],
      list: []
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getUserInfo()
      this.getList()
    })
  },
  methods: {
    ok () {
      if (this.cardCode) {
        if (!this.isSubmit) {
          this.$Loading.start()
          this.isSubmit = true
          this.isShowModalLoader = true
          this.$api.account.member.integral.card.exchange(this.cardCode, {
            success: response => {
              this.$Loading.finish()
              this.isSubmit = false
              this.isShowModalLoader = false
              if (response.data.code === 200) {
                let that = this
                this.$Message.success({
                  content: '兑换成功',
                  closable: true,
                  duration: 0.5,
                  onClose () {
                    that.cardInfo = null
                    that.getUserInfo()
                    that.getList()
                  }
                })
              } else if (response.data.code === 404) {
                this.$Message.warning({content: '卡密不正确', closable: true})
              } else if (response.data.code === 202200) {
                this.$Message.warning({content: '兑换卡已被使用', closable: true})
              } else if (response.data.code === 202201) {
                this.$Message.warning({content: '兑换卡已失效', closable: true})
              } else {
                this.$Message.warning({content: response.data.message, closable: true})
              }
            },
            error: errorMsg => {
              this.$Loading.error()
              this.isSubmit = false
              this.isShowModalLoader = false
              this.$Message.error({content: this.$t('common.tryAgain'), closable: true})
            }
          })
        }
      } else {
        this.$Message.warning({content: '请填写正确的兑换卡密码', closable: true})
      }
    },
    cardInputEvent (e, nextInput) {
      if (nextInput && e.target.value.length >= 4) {
        this.$refs[nextInput] && this.$refs[nextInput].focus()
      }
      if (this.cardNo.f1 && this.cardNo.f2 && this.cardNo.f3 && this.cardNo.f4) {
        this.cardCode = this.cardNo.f1 + this.cardNo.f2 + this.cardNo.f3 + this.cardNo.f4
        this.$api.account.member.integral.card.get(this.cardCode, {
          success: response => {
            if (response.data.code === 200) {
              this.cardInfo = response.data.data
            } else {
              this.cardInfo = null
            }
          },
          error: errorMsg => {
            this.cardInfo = null
          }
        })
      } else {
        this.cardInfo = null
      }
    },
    getUserInfo () {
      if (this.isShowLoader) return
      this.$Loading.start()
      this.isShowLoader = true
      this.$api.account.member.home({
        success: (response) => {
          this.$Loading.finish()
          if (response.data.code === 200) {
            this.userInfo = response.data.data || { statistics: {} }
            if (!this.userInfo['statistics']) this.userInfo['statistics'] = {}
          } else {
            this.$Message.warning({content: this.$t('common.codeError'), closable: true})
          }
          this.isShowLoader = false
        },
        error: (errorMsg) => {
          this.isShowLoader = false
          this.$Message.error({content: this.$t('common.tryAgain'), closable: true})
          this.$Loading.error()
        }
      })
    },
    getList (page = 1) {
      if (this.loaderQuery) return
      this.$Loading.start()
      this.loaderQuery = true
      this.$api.account.member.integral.card.history({ page: page, size: this.pageSize }, {
        success: (response) => {
          this.$Loading.finish()
          if (response.data.code === 200) {
            this.list = response.data.data.result || []
            this.total = response.data.data.count || 0
          } else {
            this.$Message.warning({content: this.$t('common.codeError'), closable: true})
          }
          this.loaderQuery = false
        },
        error: (errorMsg) => {
          this.loaderQuery = false
          this.$Message.error({content: this.$t('common.tryAgain'), closable: true})
          this.$Loading.error()
        }
      })
    }
  }
}
</script>
<style scoped>
.table_content{
  position: relative;
  background-color: #fff;
  padding: 18px 22px 32px;
}
.expire_jf{
  font-size: 12px;
  color: #999;
  position: absolute;
  top: 28px;
  right: 26px;
  z-index: 1;
}
.form-icon2{
  background: url("~@/assets/images/icons/member/icon_jfdh.png") 0 0 no-repeat transparent;
  width: 15px;
  height: 9px;
  background-size: auto 9px;
  z-index: 1;
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  margin-top: 0.5px;
}
.content{
  margin-bottom: 30px;
}
.content .header{
  border-bottom: 1px solid #E8E8E8;
  padding: 18px 22px 22px;
  margin-bottom: 15px;
  background-color: #fff;
}
.content .header h1{
  font-size: 16px;
  font-weight: normal;
  color: #333;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}
.content .header h1 span{
  color: #999;
  font-size: 12px;
  padding-left: 30px;
}
.content .header .stat,
.content .header .stat .stat_wrap,
.stat_wrap_content{
  position: relative;
  display: flex;
  align-items: center;
}
.subcribe{
  position: absolute;
  top: 42px;
  left: 220px;
  font-size: 12px;
  color: #666;
}
.info{
  position: absolute;
  top: 42px;
  right: 35px;
  font-size: 12px;
  color: #666;
}
.info .times{
  color: #1F8AFD;
}
.info span{
  padding-left: 6px;
}
.content .header .stat .title{
  color: #999;
  font-size: 12px;
}
.content .header .stat .card_type{
  border: 1px solid #1F8AFD;
  border-radius: 3px;
  width: 130px;
  height: 30px;
  line-height: 28px;
  text-align: center;
  color: #1F8AFD;
  margin: 0 36px 0 5px;
  position: relative;
}
.content .header .stat .card_type img{
  position: absolute;
  bottom: 0;
  right: 0;
  width: 12px;
}
.content .header .stat .inputs{
  margin-right: 30px;
}
.content .header .stat .inputs span{
  float: left;
  color: #ccc;
  display: block;
  height: 30px;
  line-height: 30px;
}
.content .header .stat >>> .ivu-input-wrapper{
  float: left;
  width: auto;
}
.content .header .stat .inputs >>> .ivu-input{
  width: 70px;
  margin-left: 5px;
  margin-right: 5px;
  border: 1px solid #DADADA;
  border-radius: 3px;
  height: 30px;
  line-height: 28px;
  padding: 0 5px;
  text-align: center;
}
.content .header .stat .inputs >>> .ivu-input:focus{
  border-color: #57a3f3;
}
.content .header .stat .btn{
  cursor: pointer;
  border: 0 none;
  padding: 0;
  background-image: linear-gradient(90deg, #42BEFF 9%, #1F8AFD 100%);
  border-radius: 3px;
  height: 30px;
  line-height: 30px;
  width: 100px;
  font-size: 12px;
  text-align: center;
  color: #fff;
}
.content >>> .ivu-tabs-bar{
  border-bottom: 0 none;
  margin-bottom: 0;
}
.content >>> .ivu-tabs-nav .ivu-tabs-tab-active{
  color: #333;
  padding-bottom: 15px;
  padding-left: 1px;
}
.content >>> .ivu-tabs-ink-bar{
  /*background-color: #1F8AFD;*/
  display: none;
}
.content >>> .ivu-table-wrapper,
.content >>> .ivu-table th,
.content >>> .ivu-table td{
  border-color: #E8E8E8;
  font-weight: normal;
  font-size: 13px;
}
.content >>> .ivu-table-cell{
  color: #333;
}
.content >>> .ivu-table td.time .ivu-table-cell{
  color: #999;
}
.content >>> .ivu-spin-fix{
  border-color: #E8E8E8;
  background-color: rgba(255, 255, 255, .7);
}
.content >>> .ivu-table-tip{
  color: #999;
}
.content >>> tr.ivu-table-row-hover td{
  /* background-color: #edf8ff; */
}
.content >>> .ivu-page{
  margin: 25px 0 10px;
  text-align: center;
}
.content >>> .ivu-page.mini .ivu-page-item{
  border: 1px solid #EDEDED;
  margin: 0 3px;
}
.content >>> .ivu-page.mini .ivu-page-item a{
  color: #999;
  font-size: 13px;
}
.content >>> .ivu-page-item-active{
  background-color: #1F8AFD;
}
.content >>> .ivu-page.mini .ivu-page-item.ivu-page-item-active a{
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/member/zh-CN/integral/Content.vue